import { useGlobalCommandPaletteContext } from './GlobalCommandPaletteProvider';

/**
 * Hook público para abrir/cerrar el Global Command Palette
 * 
 * @example
 * const { isOpen, setIsOpen, toggle } = useGlobalCommandPalette();
 * 
 * // Abrir el palette
 * setIsOpen(true);
 * 
 * // Toggle
 * toggle();
 */
export function useGlobalCommandPalette() {
    return useGlobalCommandPaletteContext();
}
